/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type KillswitchComingSoonCapability = {
  label: string;
};

/** @internal */
export const KillswitchComingSoonCapability$inboundSchema: z.ZodMiniType<
  KillswitchComingSoonCapability,
  unknown
> = z.object({
  label: z.string(),
});

export function killswitchComingSoonCapabilityFromJSON(
  jsonString: string,
): SafeParseResult<KillswitchComingSoonCapability, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => KillswitchComingSoonCapability$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'KillswitchComingSoonCapability' from JSON`,
  );
}
